export const Description = ({ color }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6H16" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M4 10H16" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M4 14H11" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
